/**
 * Scoped loader for the Isola Plus dashboard: an overlay is appended only to the given element
 * (list, modal, ...) and makes everything inside it non-interactive until stopped.
 * Buttons keep using the global `$.fn.spinner()` (see `.btn-loader`).
 */

const LOADER_SELECTOR = '> .sor-loader';

/**
 * Show a loader overlay on top of the target and block any interaction with it
 * @param {jQuery} $target - element to cover
 */
const start = function ($target) {
  if (!$target || !$target.length || $target.children('.sor-loader').length) {
    return;
  }
  $target.addClass('sor-loader-host').attr('aria-busy', 'true');
  $target.append('<div class="sor-loader"><div class="spinner"><div class="dot1"></div><div class="dot2"></div></div></div>');
  // keyboard users must not be able to reach the covered controls either
  $target.children().not('.sor-loader').attr('inert', '');
};

/**
 * Remove the loader overlay added by start()
 * @param {jQuery} $target - element covered by the loader
 */
const stop = function ($target) {
  if (!$target || !$target.length) {
    return;
  }
  $target.find(LOADER_SELECTOR).remove();
  $target.children('[inert]').removeAttr('inert');
  $target.removeClass('sor-loader-host').removeAttr('aria-busy');
};

/**
 * Get the element to cover for a modal (or the modal the given element lives in)
 * @param {jQuery} $element - modal container or any element inside the modal
 * @returns {jQuery} the modal content
 */
const getModalHost = function ($element) {
  let $host = $element.closest('.modal-content');
  if (!$host.length) {
    $host = $element.find('.modal-content').first();
  }
  if (!$host.length) {
    $host = $element.closest('.ui-dialog');
  }
  if (!$host.length) {
    $host = $element.parents('.ui-dialog').first();
  }
  return $host;
};

module.exports = {
  start: start,
  stop: stop,
  getModalHost: getModalHost
};
